import { j as o } from "../../../jsx-runtime-82a9ddf6.js";
const i = ({ width: r = 20, height: t = 20, className: e, style: n }) => /* @__PURE__ */ o.jsx(
  "svg",
  {
    width: r,
    height: t,
    className: e,
    style: n,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ o.jsxs("g", { id: "Icons / Payments", children: [
      /* @__PURE__ */ o.jsx("path", { id: "Vector", d: "M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ o.jsx("path", { id: "Vector_2", d: "M12.3333 7.5C12.1824 7.23814 11.963 7.02226 11.6988 6.87546C11.4346 6.72867 11.1354 6.6565 10.8333 6.66667H9.16667C8.72464 6.66667 8.30072 6.84226 7.98816 7.15483C7.6756 7.46739 7.5 7.89131 7.5 8.33334C7.5 8.77536 7.6756 9.19929 7.98816 9.51185C8.30072 9.82441 8.72464 10 9.16667 10H10.8333C11.2754 10 11.6993 10.1756 12.0118 10.4882C12.3244 10.8007 12.5 11.2246 12.5 11.6667C12.5 12.1087 12.3244 12.5326 12.0118 12.8452C11.6993 13.1577 11.2754 13.3333 10.8333 13.3333H9.16667C8.86458 13.3435 8.56541 13.2713 8.30118 13.1245C8.03696 12.9778 7.81763 12.7619 7.66667 12.5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ o.jsx("path", { id: "Vector_3", d: "M10 13.3333V15M10 5V6.66667V5Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
    ] })
  }
);
export {
  i as PaymentsIcon
};
